import React, {
    memo,
    RefObject,
    useCallback,
    useRef,
    useState
} from "react";
import styles from "./VideoReactions.module.css";
import {
    REACTION_TYPES,
    ReactionType,
    Video
} from "../../../../../common/video/models/Video";
import ReactionEmoji from "../../ReactionEmoji";
import {useDispatch, useSelector} from "react-redux";
import {
    addVideoReaction,
    AddViewingHistory
} from "../../../../../common/video/VideoActions";
import {VideoReaction} from "../../../../../common/video/models/VideoReaction";
import {AppState} from "../../../../../root/RootReducer";
// import { Line } from "react-chartjs-2";
// import { defaults } from "chart.js";
import {
    Collapse,
    createStyles,
    FormControlLabel,
    makeStyles,
    Switch
} from "@material-ui/core";
import PuiTypography from "../../../../../components/elements/PuiTypography";
import {UpdateStatistics} from "../../../../../store/actions/ExVideoActions";

const useStyles = makeStyles(() =>
    createStyles({
        switch: {
            "& .MuiSwitch-track": {
                backgroundColor: "var(--gray-61)"
            },
            "& .MuiSwitch-colorSecondary.Mui-checked": {
                color: "var(--red)"
            },
            "& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "var(--red)"
            }
        }
    })
);

interface VideoReactionProps {
  reactions: VideoReaction[];
  videoId: number;
  videoDuration: number;
  videoRef: RefObject<HTMLVideoElement>;
  video: Video;
}

interface TimeLineReactionProps {
  reaction: VideoReaction;
  width: number;
  videoDuration: number;
}

function TimeLineReaction({
    reaction,
    width,
    videoDuration
}: TimeLineReactionProps) {
    // relative position, -8px to account for center of 16px wide marker
    const actualPosition =
    (reaction.reactionTimeMillis * width) / videoDuration - 8;
    return (
        <div
            className={styles.timelineReaction}
            key={reaction.id}
            style={{left: `${actualPosition}px`, top: "6px"}}
        >
            <ReactionEmoji reaction={reaction.type}/>
        </div>
    );
}

const MemoedTimeLineReaction = memo(TimeLineReaction);

// TODO split up and simplify the file
function VideoReactions({
    reactions,
    videoId,
    videoDuration,
    videoRef,
    video
}: VideoReactionProps) {
    const dispatch = useDispatch();
    const classes = useStyles();

    const {userInfo} = useSelector((state: AppState) => ({
        userInfo: state.user.userInfo
    }));

    const [currentReatcions, setCurrentReatcions] = useState<VideoReaction[]>(
    // 全てのレクレーション表示
        reactions
    );
    const [show, setShow] = useState<boolean>(true);

    // タグフォーマット
    const makeTagStr = (videoTags: string[]) => {
        let tagList = "";
        for (let index = 0; index < videoTags.length; index++) {
            tagList = tagList.concat(videoTags[index]);
        }
        return tagList;
    };

    const submitReaction = useCallback(
        async (type: ReactionType) => {
            if (videoRef.current) {
                const reactionTimeMillis = Math.floor(
                    videoRef.current.currentTime * 1000
                );

                // リアクションクリック時の閲覧時刻登録
                if (userInfo) {
                    dispatch(
                        AddViewingHistory(userInfo.id, videoId, reactionTimeMillis + 1600)
                    );
                    dispatch(
                        UpdateStatistics(
                            Number(userInfo.id),
                            video.id,
                            makeTagStr(video.tags),
                            video.title,
                            video.imageUrl,
                            reactionTimeMillis + 1600,
                            false
                        )
                    );
                }

                dispatch(
                    addVideoReaction({
                        id: videoId,
                        userId: userInfo ? parseInt(userInfo.id) : 1,
                        type: type,
                        reactionTimeMillis: reactionTimeMillis
                    })
                );

                const newReaction: VideoReaction = {
                    id: 0,
                    videoId: videoId,
                    userId: userInfo ? parseInt(userInfo.id) : 1,
                    type: type,
                    reactionTimeMillis: reactionTimeMillis,
                    created: new Date()
                };

                setCurrentReatcions([...currentReatcions, newReaction]);
            }
        },
        [videoId, videoRef, dispatch, userInfo, currentReatcions, video]
    );

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShow(event.target.checked);
    };

    const refObject = useRef<HTMLDivElement>(null);
    const width = refObject.current?.getBoundingClientRect().width || 0;

    // const countPeriod = videoDuration / 50;
    // const [reactionCount, setReactionCount] = useState<number[]>([]);
    // const [labelGroup, setLabelGroup] = useState<string[]>([]);

    //   defaults.animation = false;

    // useEffect(() => {
    //     const reactionGroup: number[] = [];
    //     const labels: string[] = [];

    //     if (reactions.length > 0) {
    //         for (let time = 0; time <= videoDuration; time += countPeriod) {
    //             const filterData: VideoReaction[] = reactions.filter(
    //                 (r) =>
    //                     r.reactionTimeMillis >= time &&
    //         r.reactionTimeMillis < time + countPeriod
    //             );
    //             reactionGroup.push(filterData.length);
    //         }

    //         setReactionCount(reactionGroup);

    //         reactionGroup.forEach((item) => labels.push(""));
    //         setLabelGroup(labels);
    //     }
    // }, [reactions, videoDuration, countPeriod]);

    // const data = {
    //     labels: labelGroup,
    //     datasets: [
    //         {
    //             label: "reaction",
    //             data: reactionCount,
    //             fill: true,
    //             backgroundColor: "rgb(151, 153, 155)",
    //             borderColor: "rgba(151, 153, 155)",
    //             tension: 0.3
    //         }
    //     ]
    // };

    // const graphOptions = {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     chartArea: {backgroundColor: "black"},
    //     elements: {
    //         point: {
    //             pointRadius: 1,
    //             pointBorderWidth: 0.1,
    //             pointHoverRadius: 3
    //         }
    //     },
    //     scales: {
    //         y: {display: false},
    //         x: {display: false}
    //     },
    //     layout: {
    //         padding: {left: 12, right: 13, top: 0, bottom: 0}
    //     },
    //     plugins: {
    //         legend: {display: false}
    //     }
    // };

    return (
        <>
            <div className={styles.ControllerWrapper}>
                <FormControlLabel
                    control={
                        <Switch
                            size="small"
                            checked={show}
                            onChange={handleChange}
                            name="showReaction"
                            className={classes.switch}
                        />
                    }
                    label={
                        <PuiTypography size={14} color={"gray-61"}>
              リアクション表示
                        </PuiTypography>
                    }
                    labelPlacement="start"
                    style={{width: "160px"}}
                />
            </div>
            <Collapse in={show} timeout="auto" unmountOnExit>
                <div className={styles.reactionGraphWrapper}>
                    {/* <Line data={data} type="bar" height={50} options={graphOptions} /> */}
                </div>
                <div className={styles.reactionTimelineWrapper}>
                    <div
                        className={styles.reactionTimeline}
                        ref={refObject}
                        onClick={(e) => {
                            // リアクション位置に移動
                            const position =
                ((e.clientX - e.currentTarget.offsetLeft) /
                  e.currentTarget.clientWidth) *
                100;
                            if (videoRef && videoRef.current) {
                                videoRef.current.currentTime =
                  (videoDuration * position) / 100 / 1000;
                            }
                        }}
                    >
                        {currentReatcions && currentReatcions.map((reaction) => (
                            <MemoedTimeLineReaction
                                videoDuration={videoDuration}
                                width={width}
                                reaction={reaction}
                                key={reaction.id}
                            />
                        ))}
                    </div>
                </div>
                <div className={styles.reactions}>
                    <div className={styles.addReaction}>
                        {REACTION_TYPES.map((reaction: ReactionType) => (
                            <ReactionAdder
                                key={reaction}
                                reaction={reaction}
                                addReaction={submitReaction}
                            />
                        ))}
                    </div>
                </div>
            </Collapse>
        </>
    );
}

interface ReactionAdderProps {
  reaction: ReactionType;
  addReaction: (reaction: ReactionType) => void;
}

function ReactionAdder({reaction, addReaction}: ReactionAdderProps) {
    const clickHandler = useCallback(
        () => addReaction(reaction),
        [reaction, addReaction]
    );
    return (
        <div className={styles.addReactionListEntry} onClick={clickHandler}>
            <ReactionEmoji reaction={reaction}/>
        </div>
    );
}

export default memo(VideoReactions);
